import { statusUser, v2UserStatus, v4UserStatus, requestMagicLinkUser } from '@goldcast/api/backend';

import { getEventUserInfo } from '@/services/eventUserInfoApi';

export async function getUserStatus(payload, usePentestFlow = false) {
  if (usePentestFlow) {
    if (payload.isUserLoggedIn) {
      return await getEventUserInfo({
        eventId: payload.event,
        legacy: () => v4UserStatus({ body: payload }),
        mapResponse: info => ({
          name: info.name,
          registeredToEvent: info.registeredToEvent,
          isOrganizer: info.isOrganizer,
          isSpecialUser: info.isSpecialUser,
          blocked: info.blocked,
          agendaFavorites: info.agendaFavorites,
          event_organization: info.event_organization
        })
      });
    } else if (payload.email && payload.event) {
      // requestMagicLinkUser requires both; callers without event (e.g. entry.vue non-event path) fall through
      return await requestMagicLinkUser({ body: { email: payload.email, event: payload.event } });
    } else {
      return await statusUser({ body: payload });
    }
  } else {
    if (payload.isUserLoggedIn) {
      return await v2UserStatus({ body: payload });
    } else {
      return await statusUser({ body: payload });
    }
  }
}
